import { Component, Input, OnInit,ViewEncapsulation } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  styleUrls: ['./country-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CountryListComponent implements OnInit {
@Input('data') data: any;
  countries: any;
  backupCountries: any;
  sku:any;
  parentCategory:any='';
  lang:any='';
constructor(    private modalController: ModalController,
  private UTS: UtilitiesService,

  ) {  

}

  ngOnInit() {
    this.countries = this.data?.countries;
    this.sku = this.data?.sku;
    this.backupCountries = JSON.parse(JSON.stringify(this.data?.countries || ''));
    this.parentCategory = localStorage.getItem('ParentCategory') || '';
    this.lang = this.UTS.getLocaleLanguage();
  }

  async filterList(evt) {
    this.countries = this.backupCountries;
    const searchTerm = evt.srcElement.value;
  
    if (!searchTerm) {
      return;
    }
  
    this.countries = this.countries.filter(currentFood => {
      if (currentFood.countryName && searchTerm) {
        return (currentFood.countryName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1)
      }
    });
  }

  dismiss(){
    this.modalController.dismiss();
  }

  replaceNumber(data:any){
    const value :any =  data & data.replace(/^0+/, '') || ''; 
    return  value;
  }

}
